import React from 'react';
import PropTypes from 'prop-types';
import { connectRefinementList, Highlight } from 'react-instantsearch-dom';
import Input from '../../Input';
import Typography from '../../Typography';

const RefinementList = ({ items, isFromSearch, refine, searchForItems, searchable, title }) => (
  <>
    <Typography variant="overline" className="mb-16 d-block">
      {title}
    </Typography>
    <ul className="list-unstyled mb-40">
      {searchable && (
        <li className="pb-24">
          <Input
            showLabel={false}
            label="Search"
            type="search"
            onChange={event => searchForItems(event.target.value)}
          />
        </li>
      )}
      {items.map(item => (
        <li key={item.label} className="pb-8">
          {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
          <div
            className="form-check"
            onClick={event => {
              event.preventDefault();
              refine(item.value);
            }}
          >
            <input
              className="form-check-input"
              type="checkbox"
              value={item.value}
              checked={item.isRefined}
              id="defaultCheck1"
            />
            <label className="form-check-label" htmlFor="defaultCheck1">
              {isFromSearch ? <Highlight attribute="label" hit={item} /> : item.label} ({item.count})
            </label>
          </div>
        </li>
      ))}
    </ul>
  </>
);

RefinementList.propTypes = {
  isFromSearch: PropTypes.bool,
  items: PropTypes.array,
  refine: PropTypes.func,
  searchForItems: PropTypes.func,
  searchable: PropTypes.bool,
  title: PropTypes.string,
};

RefinementList.defaultProps = {
  isFromSearch: false,
  items: [],
  refine: undefined,
  searchForItems: undefined,
  searchable: false,
  title: undefined,
};

export default connectRefinementList(RefinementList);
